import { Notification } from "./Notification";
import { notifications } from "./stores";
export class NotificationService {
    createNotification(message) {
        notifications.update(notifications => [...notifications, new Notification(message)]);
    }
    dismissNotification(notification) {
        notifications.update(notifications => notifications.filter((item) => item !== notification));
    }
}
